const initState = {
    search: '',
    data: [],
    page: 1,
    loadDataSearch: false
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'ON_QUICK_SEARCH': {
            return {
                ...state,
                fetching: true,
                loadDataSearch: true
                // page: action.payload.page
            }
        }
        case 'QUICK_SEARCH_SUCCESS':
            let copy = { ...state }
            let result = []
            let arrayOrders = action.payload[0].data.data.QuickSearchOrderResults
            let arrayShipments = action.payload[1].data.data.QuickSearchShipmentResults

            arrayOrders.map(a => {
                a.ID = 'o' + a.ID
            })
            arrayShipments.map(a => {
                a.ID = 's' + a.ID
            })

            const maxPage = Math.max(action.payload[0].data.data.PageCount, action.payload[1].data.data.PageCount)
            for (let i = 0; i < 10; i++) {
                if (i < arrayOrders.length) {
                    result = [...result, arrayOrders[i]]
                }
                if (i < arrayShipments.length) {
                    result = [...result, arrayShipments[i]]
                }
            }
            return {
                ...state,
                data: [...copy.data, ...result],
                show_quick_searh: true,
                fetching: false,
                maxPage: maxPage,
                page: action.page,
                loadDataSearch: false
            }
        case 'ON_CLEAR_SEARCH':
            return {
                ...state,
                data: [],
                clear_value: undefined,
                page: 1,
            }
        case 'FROM_QUICK_SEARCH':
            return {
                ...state,
                data: [],
                from_quick_search: action.payload.FromQuickSearch ? action.payload.FromQuickSearch : false,
                tracking_no: action.payload.TrackingNumberCH ? action.payload.TrackingNumberCH : null,
            }
        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/quickSearchReducer.js